import React ,{useEffect,useState} from 'react';
import { useLocation,useNavigate } from "react-router-dom";
import apiClient from "../utils/axios";
import { ADMIN } from "../config/api";
import toast from "react-hot-toast";


function Adduser() {

  
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const userId = queryParams.get("id"); // <-- null for Add, string for Edit
    const navigate = useNavigate();
    const token = localStorage.getItem("token");

  const [formdata, setForm] = useState({ name:"",email:""});
      const [errors, setErrors] = useState({});
      const [loading, setLoading] = useState(false);
      const [message, setMessage] = useState("");

      useEffect(() => {
        if (userId) {
            const fetchuser = async () => {
                try {
                const { data } = await apiClient.get(ADMIN.GET_USER);
                if (data.success) {
                    const user = data.items.find(p => p._id === userId);
                    if (user) {
                    setForm({
                        name: user.name,
                        email: user.email,
                        pass:user.password,
                        role:user.role
                    });
                    }
                }
                } catch (err) {
                console.error("Error fetching user:", err);
                toast.error(err.response?.data?.message || err.message || "Failed to fetch user data");
                }
            };
            fetchuser();
            }
        }, [userId]);
        
    
      const validate = () => {
        const e = {};
        if (!formdata.name || formdata.name.trim().length < 3)
          e.name = "Name must be at least 3 chars";
        if (!formdata.email) e.email = "email required";
        if (!formdata.pass) e.email = "password required";
        if (!formdata.role) e.email = "role required";
        setErrors(e);
        return Object.keys(e).length === 0;
      };
    
      const formChangeData = (ev) => {
        const { name, value } = ev.target; {
            setForm((f) => ({ ...f, [name]: value }));
          }
          setMessage("");
      };
    
      const handleSubmit = async (ev) => {
    ev.preventDefault();
    if (!validate()) return;
    setLoading(true);
    setMessage("");

    try {
        const url = userId ? ADMIN.UPDATE_USER(userId) : ADMIN.USER_ADD;
        const method = userId ? "put" : "post";

        const { data } = await apiClient[method](url, formdata);
        if (!data.success) throw new Error(data?.message || "Operation failed");

        toast.success(data.message || (userId ? "User updated successfully" : "User added successfully"));
        if(!userId){
        setForm({ name:"", email:"" });
        }
        setTimeout(() => {
        navigate("/user");
        }, 1000);
    } catch (err) {
        toast.error(err.response?.data?.message || err.message || "Operation failed");
    } finally {
        setLoading(false);
    }
};

  return (
    
    <div>
        
        <div className="col-12 grid-margin container-scroller" >
            <div className="card">
                <div className="card-body" >
                <h4 className="card-title"></h4>
                <form method="post" onSubmit={handleSubmit} className="form-sample">
                    <p className="card-description"> Add User </p>
                    <div className="row">

                    <div className="col-md-6">
                        <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Name</label>
                        <div className="col-sm-9">
                            <input type="text" name="name" value={formdata.name} onChange={formChangeData} className="form-control" />
                            {errors.name && <small className="text-danger">{errors.name}</small>}
                        </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Email</label>
                        <div className="col-sm-9">
                            <input type="text" name="email" value={formdata.email} onChange={formChangeData} className="form-control" />
                            {errors.email && <small className="text-danger">{errors.email}</small>}
                        </div>
                        </div>
                    </div>
                    </div>

                    <div className="row">

                    <div className="col-md-6">
                        <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Password</label>
                        <div className="col-sm-9">
                            <input type="text" name="pass" value={formdata.pass} onChange={formChangeData} className="form-control" />
                            {errors.pass && <small className="text-danger">{errors.pass}</small>}
                        </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Role </label>
                        <div className="col-sm-9">
                            <select
                            className="form-control"
                            name="role"
                            value={formdata.role}
                            onChange={formChangeData}
                            >
                            <option value="">-- Select Role --</option>
                            <option value="admin">Admin</option>
                            <option value="manager">Manager</option>
                            <option value="kitchen">Kitchen</option>
                            <option value="customer">Customer</option>
                            </select>
                            {errors.role && <small className="text-danger">{errors.role}</small>}
                        </div>
                        </div>
                    </div>
                    </div>

                    
                    <div className="row mt-3">
                        <div className="col-md-12 text-center">
                        <button 
                            type="submit" 
                            className="btn btn-primary" 
                            >
                            Submit
                        </button>
                        </div>
                    </div>
                </form>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Adduser
